import { Breakpoint } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, ReactElement } from 'react';

interface ModalI {
  open: boolean;
  handleClose: () => void;
  children?: ReactElement | boolean;
  modalText?: string;
  modalTitle?: string;
  size?: false | Breakpoint;
  isMobile?: boolean;
}

const BaseModal: FC<ModalI> = ({
  open,
  handleClose,
  modalText,
  modalTitle,
  children,
  size = 'md',
  isMobile,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={size}
      fullScreen={isMobile}
    >
      {modalTitle && <DialogTitle>{modalTitle}</DialogTitle>}
      <DialogContent sx={{ padding: 0 }}>
        <DialogContentText>{modalText}</DialogContentText>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default BaseModal;
